import React from "react";
import { useAppDispatch } from "../../../../redux/hooks";
import useTableCtx from "../../../../components/tables/tableContext/useTableCtx";
import Text from "../../../../styleguide/Text";
import CustomButton from "../../../../components/CustomButton";
import { getDownloadRapoarteReturnareFurnizor } from "../../../../redux/api/reports.api";
import { dateForDatabase } from "../../../../utils/dateAndTime";

function ReturningProductsReportsTableHeader() {
  const dispatch = useAppDispatch();
  const { tableData, tablePagination, tableSearch } = useTableCtx() || {};

  const exportRaport = async () => {
    const formatDate: string = dateForDatabase(tableSearch.dataPV);

    await dispatch(
      getDownloadRapoarteReturnareFurnizor({
        page: tablePagination?.page,
        perPage: tablePagination?.rowsPerPage,
        user: tableSearch.user,
        provider: tableSearch.provider,
        dataPV: formatDate,
        docNrAndDate: tableSearch.docNrAndDate,
        productName: tableSearch.productName,
        lot: tableSearch.lot,
        tipPv: tableSearch.tipPv,
      }),
    );
  };

  return (
    <div className="flex justify-between mb-6">
      <Text
        variant="h3"
        component="h3"
        className="font-semibold text-slate-900 mb-4"
        gutterBottom>
        Rapoarte returnare produse catre furnizor
      </Text>
      {tableData && tableData?.length > 0 && (
        <CustomButton
          variant="contained"
          withConfirmationModal={{
            modalTitle: "Exporta raport",
            modalSubtitle: "Esti sigur ca vrei sa exporti raportul?",
            modalLeftButtonText: "Anuleaza",
            modalLeftButtonVariant: "outlined",
            modalRightButtonText: "Exporta",
            modalRightButtonOnClick: exportRaport,
          }}>
          Exporta raport
        </CustomButton>
      )}
    </div>
  );
}

export default ReturningProductsReportsTableHeader;
